export const Widths = {
  xxs: "240px",
  xs: "320px",
  sm: "400px",
  md: "480px",
  lg: "560px",
  xl: "640px",
  xxl: "720px",
  "2xl": "1024px",
  "3xl": "1280px",
  "4xl": "1440px",
  "5xl": "1600px",
  "6xl": "1920px",
  paragraphMaxWidth: "720px",
} as const;

export type Width = typeof Widths;
